import { Button, Col, Flex, Progress, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { selectCourse } from "../features/courses/coursesSlice";
import { useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";

export const CourseResult = ({ results, questions, onRetry, onNext }) => {
    const data = useSelector((state) => selectCourse(state));
    const navigate = useNavigate();
    const [stats, setStats] = useState({});
    const [showResults, setShowResults] = useState(true);

    // Memoize the data and results objects
    const memoizedData = useMemo(() => data, [data]);
    const memoizedResults = useMemo(() => results, [results]);

    useEffect(() => {
        if (memoizedResults && Object.keys(memoizedResults).length > 0) {
            const stats = {
                points: 0,
                totalPoints: 0,
                totalQuestions: 0,
                correct: 0,
                wrong: 0,
                percentage: 0,
            };
            stats.points += memoizedResults.stats.points;
            stats.totalPoints += memoizedResults.stats.totalPoints;
            stats.totalQuestions += memoizedResults.stats.totalQuestions;
            stats.correct += memoizedResults.stats.correct;
            stats.wrong += memoizedResults.stats.wrong;
            stats.percentage = ((stats.points / stats.totalPoints) * 100).toFixed(0);
            if (stats.totalQuestions === 0) setShowResults(false);
            setStats(stats);
        } else {
            if (memoizedData.attributes.progress) {
                const stats = {
                    points: 0,
                    totalPoints: 0,
                    totalQuestions: 0,
                    correct: 0,
                    wrong: 0,
                    percentage: 0,
                };
                for (const key in memoizedData.attributes.progress) {
                    const progress = memoizedData.attributes.progress[key];
                    if (!progress.stats) continue;
                    stats.points += progress.stats.points;
                    stats.totalPoints += progress.stats.totalPoints;
                    stats.totalQuestions += progress.stats.totalQuestions;
                    stats.correct += progress.stats.correct;
                    stats.wrong += progress.stats.wrong;
                }
                stats.percentage = ((stats.points / stats.totalPoints) * 100).toFixed(0);
                if (stats.totalQuestions === 0) setShowResults(false);
                setStats(stats);
            }
        }
    }, [memoizedResults, memoizedData]);

    return (
        <div className="QuizResults">
            {showResults ? (
                <>
                    <Progress type="circle" percent={stats.percentage} strokeColor="#7A65FA" />
                    <div className="QuizResultsInfo">
                        <Row>
                            <Col span={12}>Points</Col>
                            <Col span={12}>
                                {stats.points} / {stats.totalPoints}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>Questions</Col>
                            <Col span={12}>{stats.totalQuestions}</Col>
                        </Row>
                        <Row>
                            <Col span={12}>Correct</Col>
                            <Col span={12}>{`${stats.correct}`}</Col>
                        </Row>
                        <Row>
                            <Col span={12}>Wrong</Col>
                            <Col span={12}>{`${stats.wrong}`}</Col>
                        </Row>
                    </div>
                    <div className="QuizResultsAnswers">
                        <h3>Quiz Results</h3>
                        <ul className="QuizResultsList">
                            {questions.map((question, index) => {
                                const result = memoizedResults.progress[question.id];
                                const selectedAnswers = [];
                                result?.answer.forEach((answer) => {
                                    const option = question.answers.find((option) => option.id === answer);
                                    selectedAnswers.push(option.Answer);
                                });
                                return (
                                    <li key={index} className={result?.isCorrect ? "Correct" : "Incorrect"}>
                                        <div>
                                            <strong>{question.title}</strong>
                                            <span>
                                                <em>Your answer:</em> {selectedAnswers.join(", ")}
                                            </span>
                                        </div>
                                        <span>{result?.isCorrect ? "Correct" : "Incorrect"}</span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </>
            ) : (
                <>
                    <h3>You have successfully completed this course</h3>
                </>
            )}

            <Flex justify="center" align="center">
                {/* <Button onClick={() => navigate("/courses")}>Back to Courses</Button> */}
                {onRetry && (
                    <Button style={{ marginRight: 10 }} onClick={onRetry}>
                        Retry
                    </Button>
                )}
                {onNext && <Button onClick={onNext}>Next</Button>}
            </Flex>
        </div>
    );
};
